import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { LANGUAGES } from '@app/constants';
import { AuthFacade, provideAuth } from './core/auth';

/**
 * Application-wide providers — deliberately limited to what must exist before any
 * route is resolved.
 *
 * The 11 domain `provideXRepository()` calls used to live here. Everything this file
 * imports is eager, so each of them statically pulled its concrete
 * `Supabase*Repository` (and every mapper behind it) into the initial bundle. They
 * now live on the lazily loaded shell routes via `provideDomainLayer()` — see
 * [core/domain.providers.ts](./core/domain.providers.ts). Do not add a repository
 * provider back here; add it to the route file for the branch that needs it.
 *
 * `provideAuth()` stays: the route guards resolve before any lazy chunk loads, and
 * they depend on `AuthFacade`.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    MessageService,

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      lang: LANGUAGES.ENGLISH,
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          // Must stay in sync with two other places or dark mode silently
          // half-applies: the `@custom-variant dark` in styles.css (which drives
          // every Tailwind `dark:` utility) and the class ThemeService toggles on
          // <html> (LOCAL_STORAGE.DARK_MODE). All three are '.dark' / 'dark'.
          // This used to be '.my-app-dark', a string that appeared nowhere else.
          // darkModeSelector: '.dark',
        },
      },
    }),
    provideAuth(),

    // provideAppInitializer(() => {
    //   const authService = inject(AuthFacade);
    //   return authService.initializeAuth();
    // }),
  ]
};
